import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolavasacitycabs() {



  const cardData =
  {
    keyword: 'Pune to Lavasa City Cabs',
    heading: 'Sai Trupti Cabs: Pune to Lavasa City Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Lavasa City cab services, designed to make your out-station journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Lavasa City. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Lavasa City convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Lavasa with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Lakeside Promenade",
    "description": "The Lakeside Promenade is the heart and soul of Lavasa — a picturesque walkway that stretches along the shimmering Warasgaon Lake. Designed in vibrant European style, it features colorful buildings, chic cafés, and boutique shops that make every stroll a delight. Visitors enjoy cycling, boating, and simply sitting by the waterfront as cool breezes ripple across the lake. At night, the promenade lights up beautifully, creating a romantic glow over the water. Whether you’re sipping coffee at a lakeside café or taking sunset photos with the hills in the background, this area perfectly captures Lavasa’s modern charm and serene atmosphere."
  },
  {
    "title": "Varasgaon Lake",
    "description": "Varasgaon Lake is the lifeline of Lavasa, offering both scenic splendor and adventure activities for visitors. Surrounded by lush green hills and dense forests, the lake’s calm waters invite you to experience boating, kayaking, and jet-skiing in a peaceful setting. The reflection of colorful Lavasa buildings shimmering on the surface creates postcard-perfect views. Bird lovers often spot kingfishers and herons gliding over the lake. The serenity of this place is unmatched — ideal for those looking to reconnect with nature while soaking in Lavasa’s tranquil energy. Every moment spent here feels like an escape into paradise."
  },
  {
    "title": "Temghar Dam",
    "description": "Temghar Dam, located a short drive from Lavasa, is a massive structure built across the Mutha River that supplies water to Pune and nearby areas. The dam offers panoramic views of blue waters framed by emerald hills, making it a popular stop for photographers and nature lovers. During the monsoon, mist rolls across the dam and water gushes powerfully over the spillway, creating a breathtaking sight. Visitors often enjoy tea and corn from nearby stalls while taking in the cool breeze and scenic beauty. Temghar Dam is where nature’s raw energy meets serene landscape — a true feast for the senses."
  },
  {
    "title": "Bamboosa",
    "description": "Bamboosa is Lavasa’s creative hub — an eco-art center dedicated to bamboo craftsmanship and sustainable design. The facility showcases how bamboo can be transformed into exquisite furniture, décor, and art pieces by local artisans. Visitors can take guided tours to watch artisans at work, explore the display gallery, or buy souvenirs that promote sustainable living. The earthy scent of bamboo and the gentle rhythm of tools striking wood create an atmosphere of creativity and calm. Bamboosa beautifully blends art, environment, and community — offering a unique cultural experience within Lavasa’s modern skyline."
  },
  {
    "title": "Adventure Sports Park",
    "description": "For thrill-seekers, Lavasa’s Adventure Sports Park is a paradise filled with excitement and adrenaline. Activities like zip-lining, rock climbing, rappelling, and ATV rides take place amidst lush hills and scenic trails. Water sports such as jet skiing, kayaking, and pedal boating add a refreshing twist for visitors of all ages. The park maintains high safety standards while ensuring maximum fun. Whether you’re traveling with friends, family, or colleagues, this is the perfect place to test your courage and make unforgettable memories in Lavasa’s adventure-filled landscape."
  },
  {
    "title": "Lakeshore Watersports",
    "description": "Lakeshore Watersports is Lavasa’s prime destination for those who love the thrill of water adventures. Offering everything from kayaking and jet skiing to pedal boats and pontoons, it provides endless fun right on the Warasgaon Lake. Safety gear and trained guides make it suitable even for beginners. As you glide across the shimmering blue waters surrounded by the Sahyadri hills, the experience feels both peaceful and exhilarating. With the sun reflecting off the lake and cool mountain air brushing your face, Lakeshore Watersports gives Lavasa its unmistakable spirit of freedom and joy."
  },
  {
    "title": "The Dasvino Town & Country Club",
    "description": "The Dasvino Town & Country Club represents Lavasa’s luxurious side, combining elegance, leisure, and wellness under one roof. This exclusive club offers fine dining restaurants, a lavish spa, infinity pool, gym, and lounge areas overlooking the lake. Guests can relax with yoga sessions, enjoy gourmet meals, or simply unwind by the water. The architecture blends Mediterranean aesthetics with modern sophistication, making it a popular spot for weekend travelers. It’s the perfect retreat for those seeking comfort, class, and calm amid Lavasa’s enchanting hillside beauty."
  },
  {
    "title": "Nature Trails and Cycling Paths",
    "description": "Lavasa’s beautifully maintained nature trails and cycling routes make it one of India’s most pedestrian-friendly hill towns. The paths wind through forests, lakesides, and scenic ridges where every turn opens to a new view of misty mountains and colorful architecture. Cyclists can rent bikes from local shops, while walkers enjoy spotting butterflies and birds along the way. Morning mist and chirping birds create the perfect setting for mindfulness and rejuvenation. These trails reflect Lavasa’s eco-city concept — blending health, nature, and recreation seamlessly for visitors of all ages."
  },
  {
    "title": "Dasve Viewpoint",
    "description": "Dasve Viewpoint offers a panoramic view of Lavasa’s valley, shimmering lake, and Mediterranean-style township from a scenic hilltop. The road leading here is lined with lush greenery and blooming flowers, making the drive itself a joy. From the top, the pastel-colored houses, calm waters, and surrounding Sahyadris form a postcard-worthy landscape. Photographers and couples especially love visiting during sunset when the entire valley glows in golden light. Dasve Viewpoint is where modern architecture meets natural majesty — a sight that captures the true essence of Lavasa."
  },
  {
    "title": "Temghar–Lavasa Ghat Road",
    "description": "The Temghar–Lavasa Ghat Road is not just a route but an experience that defines the journey to Lavasa. The winding road, flanked by dense forests, waterfalls, and panoramic hill views, makes for one of the most scenic drives in Maharashtra. Every turn offers breathtaking vistas of the valley below, especially during the monsoon when clouds descend to road level. Travelers often stop for photography, tea, and to breathe in the fresh mountain air. The Ghat road transforms an ordinary trip into a cinematic journey — truly making Lavasa a destination as beautiful as the drive itself."
  }
],



"services": [
  {
    "name": "Pune to Lavasa City Cabs",
    "description": "Book cabs from Pune to Lavasa City for a scenic and comfortable ride. Enjoy AC/non-AC options, professional drivers, spacious interiors, luggage support, and flexible pickup/drop timings. Perfect for families, couples, and tourists visiting Lavasa for leisure trips."
  },
  {
    "name": "Pune to Lavasa Taxi Service",
    "description": "Reliable taxi service from Pune to Lavasa City offering punctual pickups, AC/non-AC vehicles, professional chauffeurs, and comfortable seating. Ideal for weekend getaways, business trips, and sightseeing tours."
  },
  {
    "name": "Pune to Lavasa Car Hire",
    "description": "Hire a car from Pune to Lavasa for flexible and personalized travel. Options include Sedans, SUVs, and luxury vehicles with AC/non-AC choices, professional drivers, and ample luggage space for smooth and safe journeys."
  },
  {
    "name": "Pune to Lavasa AC Cab",
    "description": "Travel in comfort with AC cabs from Pune to Lavasa City. Offers well-maintained vehicles, professional drivers, luggage assistance, and flexible schedules for a relaxing ride to the hill station."
  },
  {
    "name": "Pune to Lavasa Non AC Cab",
    "description": "Economical non-AC cab service from Pune to Lavasa with reliable vehicles, experienced drivers, and flexible pickup/drop options. Ideal for budget-conscious travelers seeking comfortable travel."
  },
  {
    "name": "Pune to Lavasa Innova Cab",
    "description": "Spacious Innova cab service from Pune to Lavasa with AC/non-AC options, professional drivers, and luggage support. Perfect for family trips, group travel, and corporate outings to the scenic Lavasa City."
  },
  {
    "name": "Pune to Lavasa Ertiga Cab",
    "description": "Comfortable Ertiga cab service from Pune to Lavasa offering AC/non-AC options, professional chauffeurs, flexible pickup/drop timings, and ample space for luggage. Ideal for small families and groups heading to Lavasa."
  },
  {
    "name": "Luxury Cab Pune to Lavasa",
    "description": "Premium luxury cab service from Pune to Lavasa with elegant interiors, AC comfort, professional drivers, luggage assistance, and punctual service. Perfect for VIP travel, weddings, or corporate trips."
  },
  {
    "name": "Affordable Pune to Lavasa Cab",
    "description": "Budget-friendly cab service from Pune to Lavasa offering AC/non-AC options, reliable drivers, flexible schedules, and transparent fares. Ensures economical yet comfortable travel for all types of travelers."
  },
  {
    "name": "Pune to Lavasa Outstation Cab",
    "description": "Outstation cab service from Pune to Lavasa providing AC/non-AC options, professional drivers, luggage support, and flexible return schedules. Ideal for weekend getaways and long-distance travel."
  },
  {
    "name": "Pune to Lavasa One Way Cab",
    "description": "One-way cab service from Pune to Lavasa offering convenient and cost-effective travel with AC/non-AC vehicles, professional drivers, luggage assistance, and flexible pickup/drop points."
  },
  {
    "name": "Pune to Lavasa Drop Cab",
    "description": "Drop cab service from Pune to Lavasa for safe and punctual transfers. Includes AC/non-AC vehicles, professional chauffeurs, luggage support, and flexible scheduling for stress-free travel."
  },
  {
    "name": "Pune to Lavasa Corporate Cab",
    "description": "Corporate cab service from Pune to Lavasa offering professional drivers, AC/non-AC vehicles, flexible timings, and reliable service for business trips, client visits, and corporate outings."
  },
  {
    "name": "Pune to Lavasa Wedding Cab",
    "description": "Elegant wedding cab service from Pune to Lavasa with luxury vehicles, AC comfort, skilled drivers, and timely pickups. Perfect for wedding guests, family members, and event travel requirements."
  },
  {
    "name": "Pune to Lavasa Online Booking",
    "description": "Book Pune to Lavasa cabs online instantly with AC/non-AC options, professional drivers, flexible schedules, secure payments, and transparent fares. Ideal for hassle-free and convenient travel planning."
  }
],
"tableData": [
  ["Pune to Lavasa City Cabs", "Pune to Lavasa Taxi Service"],
  ["Pune to Lavasa Car Hire", "Pune to Lavasa AC Cab"],
  ["Pune to Lavasa Non AC Cab", "Pune to Lavasa Innova Cab"],
  ["Pune to Lavasa Ertiga Cab", "Luxury Cab Pune to Lavasa"],
  ["Affordable Pune to Lavasa Cab", "Pune to Lavasa Outstation Cab"],
  ["Pune to Lavasa One Way Cab", "Pune to Lavasa Drop Cab"],
  ["Pune to Lavasa Corporate Cab", "Pune to Lavasa Wedding Cab"],
  ["Pune to Lavasa Online Booking", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Lavasa City Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Pune to Lavasa City — ideal for hill station trips, leisure travel, and weekend getaways."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Lavasa cabs, starting at affordable rates depending on the car type — no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your group size, luggage, and comfort preferences for the Pune–Lavasa route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Lavasa route, ensuring a safe, smooth, and timely journey through scenic roads."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from anywhere in Pune (city, airport, or suburbs) and drop-offs at Lavasa hotels, resorts, or residences."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our cabs are regularly serviced, sanitized, and maintained to ensure comfort and reliability for your hill station trip."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Lavasa cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]

























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Lavasa City cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Lavasa City cab services for one way, round trips, sightseeing, and weekend getaways.',
  },
  {
    question: 'How can I book a cab from Pune to Lavasa City with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Lavasa City cab through our website, mobile app, or by calling our 24×7 customer support team for quick and hassle-free booking.',
  },
  {
    question: 'What cab options are available for Pune to Lavasa City travel?',
    answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit different group sizes and budgets.',
  },
  {
    question: 'Are the drivers professional and experienced for Pune to Lavasa routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with the ghat roads and scenic routes between Pune and Lavasa City, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I book a cab for sightseeing in Lavasa City?',
    answer: 'Certainly. Sai Trupti Cabs offers customizable sightseeing packages to explore Lavasa attractions like Temghar Dam, Lakeside Promenade, and Adventure Sports activities.',
  },
  {
    question: 'Is the Pune to Lavasa City cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Pune to Lavasa City so you can plan your trip at any convenient time.',
  },
  {
    question: 'What are the Pune to Lavasa City cab fares?',
    answer: 'Our Pune to Lavasa City cab fares start from approximately ₹1,800 for sedans and ₹2,500–₹3,500 for SUVs or premium cars, depending on the cab type and trip duration.',
  },
  {
    question: 'What payment options are available for Pune to Lavasa City cab booking?',
    answer: 'We accept payments through UPI, credit/debit cards, digital wallets, and bank transfers for a smooth and secure booking experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Lavasa City cabs?',
    answer: 'All our vehicles are sanitized before every trip, and our drivers adhere to strict hygiene and safety standards to ensure your comfort and safety.',
  },
  {
    question: 'Is customer support available during the Pune to Lavasa City cab journey?',
    answer: 'Yes, our 24×7 customer support team is always available to assist you throughout your Pune to Lavasa journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Kulkarni',
    feedback: 'Booked a Pune to Lavasa cab with Sai Trupti Cabs. The service was excellent—on time, clean car, and a friendly driver.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shraddha Joshi',
    feedback: 'Sai Trupti Cabs made our Pune to Lavasa trip very comfortable. Smooth booking process and reliable service throughout.',
    rating: 5,
  },
];




















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lavasa City Cabs",
  "image": "https://saitrupticabs.com/assets/images/pune-to-lavasa-cab.jpg",
  "description": "Book cabs from Pune to Lavasa City for sightseeing, weddings, or corporate trips. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1299",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-lavasa-city-cabs"
  }
};






  return (
    <div>
      <Helmet>
  <title>Pune to Lavasa City Cabs | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book cabs from Pune to Lavasa City for sightseeing, weddings, or corporate trips. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Lavasa City Cabs, Pune to Lavasa Taxi Service, Pune to Lavasa Car Hire, Pune to Lavasa AC Cab, Pune to Lavasa Non AC Cab, Pune to Lavasa Innova Cab, Pune to Lavasa Ertiga Cab, Luxury Cab Pune to Lavasa, Affordable Pune to Lavasa Cab, Pune to Lavasa Outstation Cab, Pune to Lavasa One Way Cab, Pune to Lavasa Drop Cab, Pune to Lavasa Corporate Cab, Pune to Lavasa Wedding Cab, Pune to Lavasa Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolavasacitycabs;